import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tablero-programadores',
  templateUrl: './tablero-programadores.component.html',
  styleUrls: ['./tablero-programadores.component.scss']
})
export class TableroProgramadoresComponent implements OnInit {

  @Input()
  sstsDataProgrammer:any = []

  @Output()
  eventEmitterUserFilterSearch:EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  searchLocalStorageSst(user:any,status?:any){
    this.eventEmitterUserFilterSearch.emit({user,status})
  }

}
